import { ReactNativeIpcMessage } from '@/features/mobile-app-bridge/constants/message-action-schema';
import sendIpcMessage from '@/features/mobile-app-bridge/functions/send-ipc-message';
import type PushTokenProvider from '@/features/push/types/push-token-provider';
import type { PushDeviceType } from '@/features/push/types/push-device-type';

type GetFcmTokenResult = {
  fcmToken: string | null;
  deviceType: PushDeviceType;
};

const rnPushTokenProvider: PushTokenProvider = {
  /**
   * Get the FCM token for the current device.
   * @returns The FCM token and device type.
   */
  async getToken() {
    // sendIpcMessage resolves with the unwrapped `result` payload on success
    const result = (await sendIpcMessage(
      {
        action: ReactNativeIpcMessage.enum.GET_FCM_TOKEN,
      },
      15000
    )) as GetFcmTokenResult | null | undefined;

    return {
      fcmToken: result?.fcmToken ?? null,
      deviceType: result?.deviceType ?? 'mobile_android',
    };
  },
  /**
   * Clear the FCM token for the current device.
   */
  async clearToken() {
    await sendIpcMessage(
      {
        action: ReactNativeIpcMessage.enum.CLEAR_FCM_TOKEN,
      },
      10000
    );
  },
};

export default rnPushTokenProvider;
